import { useCallback } from 'react'

import {
  PaginatedAssetGroupsDocument,
  CountAssetsDocument,
  PaginatedAssetsDocument,
  useDeleteAssetMutation,
} from '~generated/hooks'

export default function useDeleteAsset() {
  const [deleteAssetMutation, options] = useDeleteAssetMutation()

  const deleteAsset = useCallback(
    (id: string) => {
      deleteAssetMutation({
        refetchQueries: [PaginatedAssetsDocument, PaginatedAssetGroupsDocument, CountAssetsDocument],
        awaitRefetchQueries: true,
        variables: {
          id,
        },
        update: (cache, { data }) => {
          cache.evict({ id: cache.identify({ id: data.deleteAsset.id, __typename: 'AssetObj' }) })
          cache.gc()
        },
      })
    },
    [deleteAssetMutation]
  )

  return [deleteAsset, options] as const
}
